const CharacterTokenizer = require("./characterTokenizer");
class OpenParenthesis extends CharacterTokenizer{
    constructor(){
        super("parenthesis", "(");
    }
}

module.exports = OpenParenthesis;